import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import ClientIcon from '@/svg-icons/client';

const ClientSection = ({ clients, creator }) => (
  <div className="w-full">
    <div className="font-bold text-[calc(6px+0.4vw)] my-[0.6vw] flex items-center">
      <ClientIcon className="text-gray-700 mr-2 w-6 h-6 shrink-0" />
      <FormattedMessage id="client" />
    </div>

    <div className="flex flex-wrap text-[#858585] text-[calc(6px+0.4vw)] my-[1vw] pl-[calc(14px+1.8vw)]">
      <div className="w-1/2 mb-[1vw]">
        <div className="font-bold">
          <FormattedMessage id="name" />
        </div>
        <span data-cy="order-details-client">{clients.client}</span>
      </div>

      <div className="w-1/2 mb-[1vw]">
        <div className="font-bold">
          <FormattedMessage id="username" />
        </div>
        <span data-cy="order-details-creator">{creator}</span>
      </div>

      {clients.client_origin_franchisee && (
        <div className="w-1/2">
          <div className="font-bold">
            <FormattedMessage id="CLIENT_ORIGIN_FRANCHISEE" />
          </div>
          <span data-cy="order-details-client-origin-franchisee">{clients.client_origin_franchisee}</span>
        </div>
      )}
    </div>
  </div>
);

ClientSection.propTypes = {
  clients: PropTypes.object.isRequired,
  creator: PropTypes.string,
};

ClientSection.defaultProps = {
  creator: null,
};

export default ClientSection;
